import { lighten, darken } from '@mui/material/styles';

const getDesignTokens = () => ({
  typography: {
    fontFamily: "Arial",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': [
          {
            fontFamily: 'Arial',
            fontStyle: 'normal',
            fontDisplay: 'swap',
            fontWeight: 400,
            unicodeRange:
              'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
          },
        ],
        html: {
          height: '100%',
        },
        body: {
          height: '100%',
          margin: 0,
          backgroundColor: '#212529',
          overflow: 'hidden',
        },
        '#root': {
          height: '100%',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          overscrollBehaviorY: 'contain',
          paddingBottom: 'env(safe-area-inset-bottom)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: process.env.REACT_APP_COLOR_TEXT + " !important" || "white",
            },
            "&:hover fieldset": {
              borderColor: process.env.REACT_APP_COLOR_PRIMARY,
            },
            "& .Mui-focused fieldset": {
              borderColor: process.env.REACT_APP_COLOR_PRIMARY,
            },
            "& .MuiOutlinedInput-input": {
              color: process.env.REACT_APP_COLOR_TEXT || "white",
            },
            "& .MuiSvgIcon-root": {
              color: process.env.REACT_APP_COLOR_TEXT || "white !important",
            },
            "& .Mui-disabled": {
              color: process.env.REACT_APP_COLOR_TEXT || "white", // change the color of disabled text
              WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "white",
            },
            "& fieldset.MuiOutlinedInput-notchedOutline": {
              borderColor: process.env.REACT_APP_COLOR_SEARCHBAR_BORDER || "white",
            },
          },
          "& .MuiInputLabel-root": {
            color: process.env.REACT_APP_COLOR_TEXT || "white",
          },
          "& .Mui-disabled": {
            color: process.env.REACT_APP_COLOR_TEXT || "white", // change the color of disabled text
            WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "white",
          },
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: process.env.REACT_APP_COLOR_TEXT || "white",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        virtualScrollerContent: {
          backgroundColor: "#313338",
        },
      },
    },
    MuiButton: { styleOverrides: { root: { color: "white" } } },
    MuiSvgIcon: { styleOverrides: { root: { color: "white" } } },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          backgroundColor: "#313338", // Change background color of the calendar
          color: "white",
          "& .MuiSvgIcon-root": {
            color: "white !important",
          },
          "& .MuiTypography-root": {
            color: "white !important",
          },
          "& .MuiButtonBase-root": {
            color: "white !important",
          },
          "& .MuiPickersDay-today": {
            borderColor: "white !important",
          },
        },

        // day: {
        //   color: "blue", // Change color of the day numbers
        // },
        // daySelected: {
        //   backgroundColor: "blue", // Change background color of the selected day
        //   "&:hover": {
        //     backgroundColor: "red", // Change background color of the selected day when hovered
        //   },
        // },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          "& .MuiMenuItem-root": {
            color: "white !important",
          },
        },
      },
    },
    MuiClockPicker: {
      styleOverrides: {
        root: {
          "& .MuiClockNumber-root": {
            color: "white",
          },
          "& .MuiSvgIcon-root": {
            color: "white",
          },
          "& .MuiTypography-root": {
            color: "white !important",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "white",
          "& .Mui-disabled": {
            WebkitTextFillColor: "white",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "white",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-root": {
            color: process.env.REACT_APP_COLOR_TEXT || "white !important",
          },
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "white",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: process.env.REACT_APP_COLOR_PRIMARY,
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: process.env.REACT_APP_COLOR_PRIMARY, //links, highlights
      text: "black",
    },
    secondary: {
      main: process.env.REACT_APP_COLOR_SECONDARY, // category bar, headers, divider
      accent: process.env.REACT_APP_COLOR_SECONDARY_ACCENT,
    },
    sideNav: { //spinwheel and contact us side nav
      main: process.env.REACT_APP_COLOR_SIDENAV,
      light: lighten(process.env.REACT_APP_COLOR_SIDENAV, 0.2),
      dark: darken(process.env.REACT_APP_COLOR_SIDENAV, 0.3),
    },
    tertiary: {
      main: process.env.REACT_APP_COLOR_TERTIARY // selected desktopheader items and bottom nav icons, mobile home cat icons
    },
    button: {
      primary: {
        main: process.env.REACT_APP_COLOR_BUTTON_PRIMARY,
      },
      secondary: {
        main: process.env.REACT_APP_COLOR_BUTTON_SECONDARY, // deposit button desktop
      },
      danger: {
        main: process.env.REACT_APP_COLOR_BUTTON_DANGER, //mobile hot game button
      },
      faded: {
        main: process.env.REACT_APP_COLOR_BUTTON_FADED,
      },
      login: process.env.REACT_APP_COLOR_BUTTON_LOGIN,
      signup: process.env.REACT_APP_COLOR_BUTTON_SIGNUP,
      pulse: process.env.REACT_APP_COLOR_BUTTON_PULSE,
      slotIcon: "black",
    },
    bannerAnnouncement: process.env.REACT_APP_COLOR_ANNOUNCEMENT,
    mobileHomeCat: process.env.REACT_APP_COLOR_MOBILE_HOME_CAT,
    mobileLoginRegTitle: process.env.REACT_APP_COLOR_MOBILE_LOGIN_REG_TITLE,
    announcement: "black",
    header: process.env.REACT_APP_COLOR_HEADER,
    walletScreen: process.env.REACT_APP_COLOR_MOBILE_HOME_WALLET_SCREEN,
    bottomNav: process.env.REACT_APP_COLOR_BOTTOM_NAV,
    bottomNavIcon: process.env.REACT_APP_COLOR_BOTTOM_NAV_ICON,
    divider1: process.env.REACT_APP_COLOR_DIVIDER1,
    background: {
      paper: process.env.REACT_APP_COLOR_BACKGROUND_PAPER, // for boxes surrounding texts, grid etc
      secondaryPaper: process.env.REACT_APP_COLOR_BACKGROUND_SECONDARY, // main background
      tertiary: process.env.REACT_APP_COLOR_BACKGROUND_TERTIARY,
      home: process.env.REACT_APP_COLOR_BACKGROUND_HOME,
      game: process.env.REACT_APP_COLOR_BACKGROUND_GAME,
    },
  },
});

export default getDesignTokens;
